<template>
   <v-dialog v-model="dialogOpen" width="1000" class="p-3" >

        <template v-slot:activator="{ on, attrs }" class="float-right">

          <v-icon
              v-on="on"
              v-bind="attrs"
          >
            mdi-filter
          </v-icon>

        </template>
        <slot v-if="dialogOpen" ></slot>
      </v-dialog>
</template>

<script>

export default {
  name: 'FilterBtn',
  props: {
    dialog: Boolean,
    fixed: Boolean
  },
  data () {
    return {
      dialogOpen: this.$props.dialog
    }
  },
  watch: {
    dialog: function (newVal, old) {
      this.dialogOpen = newVal
    }
  },
  methods: {
  }
}
</script>

<style>
</style>
